import React, {useState, useEffect} from 'react';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from "@material-ui/core/Button";

import ListarDoc from "../../../../documento/listar/index";

import UseStyle from "../../../useStyles";
import DocBtn from "../../../../documento/botaoDownload";

import { useSnackbar } from 'notistack';

import { getDocumentosGerais } from '../../../../../services/reuniao/ReuniaoService';
import { download } from '../../../../../services/documento/DocumentoService';

const AbaDocumentosVisualizar = (props) => {

  const {dados} = props;

  const classes = UseStyle();

  const { enqueueSnackbar } = useSnackbar();

  const [gerais, setGerais] = useState([]);

  const handleDownload = async (documentoSelecionado) => {
    const { id, nome, formato } = documentoSelecionado;
    try {
      const response = await download(id);
      const url = URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      document.body.appendChild(a);
      a.download = `${nome}.${formato}`;
      a.click();
    } catch (e) {
      enqueueSnackbar('Ocorreu um erro ao realizar o download', { variant: 'error' })
    }
  }

  useEffect(() => {
    getDocumentosGerais().then((response) => {
      if (response && response.status === 200) {
        const { data } = response;
        setGerais(data)
      }
    });
  }, [])

  return (
    <>
      <Grid container spacing={6}>
        <Grid item md={8} xs={12}>
          <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap:'wrap' }}>
            <Typography className={classes.tituloAba}>Documentos para reunião</Typography>
            {/* <Button variant="outlined">Baixar todos os documentos</Button> */}
          </div>
          <div>
            <ListarDoc dados={dados} />
          </div>
        </Grid>
        <Grid item md={4} xs={12}>
          <Typography className={classes.tituloAba}>Documentos gerais</Typography>
          {gerais.length > 0 && 
          <>
            {gerais.map((arquivo, key) => (
              <>
                <div style={{marginTop:24}}>
                  <DocBtn large onClickHandle={() => handleDownload(arquivo)}>
                    <Typography>{arquivo.nome}</Typography>
                  </DocBtn>
                </div>
              </>
            ))}
           </>
          }
        </Grid>
      </Grid>
    </>
  );
}

export default AbaDocumentosVisualizar;
